import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const META = {
  "/": ["Welp – Dating with Integrity | Honest Dating Reviews & Compatibility", "Welp is a dating tool that helps people make informed relationship decisions through balanced reviews, accountability, respectful communication, and Zodiac compatibility insights."],
  "/purpose": ["The Purpose – Why Welp Exists | Welp", "Read the founder's story: how heartbreak became a platform for clarity, communication, and accountability in dating."],
  "/playlist": ["The Welp Playlist | Welp", "Songs for every stage of the heart — heartbreak, healing, and bouncing back. Listen and suggest your own."],
  "/search": ["Search Profiles | Welp", "Look up a username on any dating platform and read honest, balanced relationship experiences before you invest your heart."],
  "/review/new": ["Submit a Review | Welp", "Share a structured, honest experience about someone you interacted with on a dating platform. AI-moderated and respectful."],
  "/login": ["Sign In | Welp", "Sign in to your Welp account to search profiles, read experiences, and explore Zodiac compatibility."],
  "/register": ["Create Your Free Account | Welp", "Create your free Welp account to search profiles, read relationship experiences, respond to reviews, apologize, and explore Zodiac compatibility."],
  "/forgot-password": ["Reset Your Password | Welp", "Reset your Welp password with a secure code texted to your verified phone."],
  "/terms": ["Terms & Conditions | Welp", "The terms that govern your use of Welp: content rules, account security, review disputes and appeals, and more."],
  "/privacy": ["Privacy Policy | Welp", "How Welp collects, uses, and protects your information — including phone verification, SMS, and AI moderation."],
  "/contact": ["Contact Us | Welp", "Questions, disputes, or legal requests — reach the Welp team directly."],
  "/feedback": ["Send Feedback | Welp", "Tell us what you love and what we can do better."],
  "/report": ["Report a Serious Incident | Welp", "Report abuse, safety concerns, or serious incidents to the Welp team."],
  "/zodiac": ["Zodiac Compatibility, Natal Charts & Tarot | Welp", "Full natal charts, synastry readings, compatibility scores, and tarot — honest, warm, and personal."],
  "/my-story": ["Tell My Story | Welp", "Share your dating story in your own words on your claimed profile."],
  "/account": ["Your Account | Welp", "Manage your Welp account, picture, phone number, and reviews."],
};

export default function Seo() {
  const { pathname } = useLocation();
  useEffect(() => {
    const [title, desc] = META[pathname] || ["Welp – Dating with Integrity", META["/"][1]];
    document.title = title;
    const md = document.querySelector('meta[name="description"]');
    if (md) md.setAttribute("content", desc);
    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.setAttribute("rel", "canonical");
      document.head.appendChild(canon);
    }
    canon.setAttribute("href", `https://welp3x3.com${pathname === "/" ? "/" : pathname}`);
  }, [pathname]);
  return null;
}
